import { render, staticRenderFns } from "./AreaMedia.vue?vue&type=template&id=2ba64df0"
import script from "./AreaMedia.vue?vue&type=script&lang=js"
export * from "./AreaMedia.vue?vue&type=script&lang=js"
import style0 from "./AreaMedia.vue?vue&type=style&index=0&id=2ba64df0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports